import "./index.css";
import React from "react";
import cartoonLandscapeImg from "../../../../../../images/marketplace/cartoon-landscape.png";

export default function AddProductGuide({ onClick, hex, white }) {
  return (
    <div className="product-guide__bg-blur">
      <div className="product-guide">
        <button
          className="product-guide__close-btn"
          type="button"
          aria-label="Close"
          onClick={onClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <img
          src={cartoonLandscapeImg}
          alt="cartoon landscape"
          className="product-guide__img"
        />
        <div className="product-guide__container">
          <h1 className="product-guide__title">Let's make it fly together.</h1>
          <p className="product-guide__text">
            Product listings have a minimum <br />
            level of content to add, to ensure <br />
            optimal UX and information.
          </p>
        </div>
        <button
          className="product-guide__btn btn btn-white btn-brand-hex"
          style={{
            "--hover-color": "white",
            "--hover-text-color": "black",
            backgroundColor: hex ? hex : "white",
            color: white ? "white" : "black",
          }}
          onClick={onClick}
        >
          OK
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/AddProductGuide/index.js